import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function ResultsSection() {
  const results = ['Menos rumiación al acostarte', 'Menos tensión en el cuerpo', "Menos 'cálculo de horas' y pelea interna", "Más sensación de control: 'ya sé qué hacer mañana'", 'Un protocolo que puedes sostener incluso en semanas difíciles'];
  return <Section background="midnight" data-id="element-180">
      <div className="max-w-3xl mx-auto" data-id="element-181">
        <h2 className="text-3xl md:text-4xl font-serif text-center text-white mb-12" data-id="element-182">
          Qué cambia en 14 noches{' '}
          <span className="text-slate-500 text-2xl block mt-2 font-sans font-normal" data-id="element-183">
            (realista)
          </span>
        </h2>

        <div className="space-y-6" data-id="element-184">
          {results.map((result, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-lg hover:bg-white/5 transition-colors" data-id="element-185">
              <div className="mt-1 min-w-[24px] h-6 rounded-full bg-[#d4a574] flex items-center justify-center text-[#0f172a]" data-id="element-186">
                <Check size={14} strokeWidth={3} data-id="element-187" />
              </div>
              <p className="text-lg text-slate-200" data-id="element-188">{result}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}